/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_EmptyInputs */

const vi_stock_out_empty = /** @type {(inputs: Stock_Out_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn không có sản phẩm hoặc vật tư để xuất kho`)
};

/**

* @param {Stock_Out_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_empty = /** @type {((inputs?: Stock_Out_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_empty(inputs)
});